import { GlobalAxios } from "../axios/axios-config";
import { ICalendarExamGroupingWeb } from "../models/calendar-exam-grouping-web";

const CALENDAR_EXAM_GROUPING_WEB_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/CalendarExamGroupingWeb";

export const calendarExamGroupingWebList = (params?: any) => {
  return GlobalAxios.get<ICalendarExamGroupingWeb[]>(
    CALENDAR_EXAM_GROUPING_WEB_ROUTE + "/CalendarExamGroupingWeb",
    {
      params: params,
      paramsSerializer: { indexes: null },
    }
  );
};
